import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, FilePlus2, ListChecks } from "lucide-react";
import { adminLogout, getAdminEmail } from "../../lib/api";
import { cn } from "../../lib/utils";

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const email = getAdminEmail();

  const onLogout = () => {
    adminLogout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A] font-body">
      <header className="bg-[#001A4D] text-white">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-3">
            <img
              src="/brand/startinc-onnavy.png"
              alt="StartINC"
              className="h-8 w-auto"
            />
            <span className="text-xs uppercase tracking-widest text-[#6B8AFF] font-heading">
              Admin
            </span>
          </Link>
          <div className="flex items-center gap-5">
            <span className="hidden md:inline text-sm text-slate-300">{email}</span>
            <button
              data-testid="admin-logout"
              onClick={onLogout}
              className="inline-flex items-center gap-2 text-sm text-white hover:text-[#6B8AFF]"
            >
              <LogOut className="w-4 h-4" /> Log out
            </button>
          </div>
        </div>
        <nav className="border-t border-white/10">
          <div className="max-w-6xl mx-auto px-6 flex items-center gap-6">
            <NavTab to="/admin" label="Posts" icon={ListChecks} active={pathname === "/admin"} />
            <NavTab to="/admin/posts/new" label="New Post" icon={FilePlus2} active={pathname === "/admin/posts/new"} />
          </div>
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-10">{children}</main>
    </div>
  );
}

function NavTab({ to, label, icon: Icon, active }) {
  return (
    <Link
      to={to}
      className={cn(
        "inline-flex items-center gap-2 py-3 text-sm font-heading tracking-wide border-b-2 transition-colors",
        active
          ? "border-[#6B8AFF] text-white"
          : "border-transparent text-slate-300 hover:text-white"
      )}
    >
      <Icon className="w-4 h-4" />
      {label}
    </Link>
  );
}
